import { CtaButtonType } from '@pairy/sheard/types';
import { useAtomValue } from 'jotai';

import { v2IsThumbnailPanelOpenAtom } from '../../../../store/v2/viewer.atom';
import {
  currentPageAtom,
  isDisableHelpersAtom,
} from '../../../../store/index.atom';
import CtaButton from '../CtaButton';

import * as Styled from './index.styles';

interface Props {
  ctaButtonList?: CtaButtonType[];
  isPreview?: boolean;
  isMobileLandscape?: boolean;
}

const CtaButtonLayer = ({
  ctaButtonList,
  isPreview,
  isMobileLandscape,
}: Props) => {
  const currentPage = useAtomValue(currentPageAtom);
  const isDisableHelpers = useAtomValue(isDisableHelpersAtom);
  const isDrawerOpen = useAtomValue(v2IsThumbnailPanelOpenAtom);
  const currentCtaButton = ctaButtonList?.find(
    (item) => item.page === currentPage,
  );

  return (
    <Styled.FlexBottomWrapper
      isMobileLandscape={isMobileLandscape}
      isDisableHelpers={isDisableHelpers}
      isDrawerOpen={isDrawerOpen}
    >
      {currentCtaButton && (
        <CtaButton
          id={currentCtaButton.id}
          button={currentCtaButton.button}
          url={currentCtaButton.url}
          page={currentCtaButton.page}
          isPreview={isPreview}
        />
      )}
    </Styled.FlexBottomWrapper>
  );
};

export default CtaButtonLayer;
